/* ==========================================================================
   Ormonde Jayne — 2 x 10ml Pairs collection page
   Loaded by sections/oj-pairs-collections.liquid.
   - Keeps --oj-pairs-top in step with the fixed theme header (which pins and
     unpins on scroll) so the collection sub nav sticks directly beneath it.
   - Sub nav: smooth scroll to a collection, active label tracking (locked for
     900ms after a click), hairline once stuck, active label kept in view on
     the mobile sideways scroller.
   - EXPLORE THE PAIRS (hero) scrolls to the first rendered collection.
   - Add to bag: POST {routes.cart_add_url}.js, ADDING → ADDED (2s) → default,
     then the theme's cart drawer (which also refreshes the bag count).
   ========================================================================== */
(function () {
  'use strict';

  var root = document.querySelector('[data-oj-pairs]');
  if (!root) return;

  var docEl = document.documentElement;
  var header = document.querySelector('nav.main-header-nav');
  var nav = root.querySelector('[data-oj-pairs-nav]');
  var scroller = nav ? nav.querySelector('[data-oj-pairs-scroll]') : null;
  var links = nav ? Array.prototype.slice.call(nav.querySelectorAll('[data-oj-pairs-link]')) : [];
  var secs = Array.prototype.slice.call(root.querySelectorAll('[data-oj-pairs-sec]'));
  var cartAddUrl = (root.getAttribute('data-cart-add-url') || '/cart/add') + '.js';
  var topPx = -1;
  var ticking = false;
  var lockUntil = 0;
  var activeId = '';

  /* ---- Header offset, stuck state, active label ------------------------ */
  function headerBottom() {
    if (!header) return 0;
    return Math.max(0, Math.round(header.getBoundingClientRect().bottom));
  }
  function navHeight() { return nav ? nav.offsetHeight : 0; }

  function setActive(id) {
    if (id === activeId) return;
    activeId = id;
    links.forEach(function (a) {
      var on = a.getAttribute('data-oj-pairs-link') === id;
      a.classList.toggle('is-active', on);
      if (on) a.setAttribute('aria-current', 'true'); else a.removeAttribute('aria-current');
      if (on && scroller && scroller.scrollWidth > scroller.clientWidth) {
        var left = a.offsetLeft - 20;
        var right = a.offsetLeft + a.offsetWidth + 20;
        if (left < scroller.scrollLeft || right > scroller.scrollLeft + scroller.clientWidth) {
          scroller.scrollTo({ left: Math.max(0, left), behavior: 'smooth' });
        }
      }
    });
  }

  function sync() {
    ticking = false;
    var t = headerBottom();
    if (t !== topPx) {
      topPx = t;
      docEl.style.setProperty('--oj-pairs-top', t + 'px');
    }
    if (!nav) return;
    nav.classList.toggle('is-stuck', window.pageYOffset > 0 && nav.getBoundingClientRect().top <= t + 0.5);
    if (!links.length || Date.now() < lockUntil) return;
    var line = t + navHeight() + 24;
    var active = secs.length ? secs[0].id : '';
    for (var i = 0; i < secs.length; i++) {
      if (secs[i].getBoundingClientRect().top <= line) active = secs[i].id;
    }
    setActive(active);
  }
  function request() {
    if (ticking) return;
    ticking = true;
    window.requestAnimationFrame(sync);
  }
  var settleA, settleB;
  function onScroll() {
    request();
    /* the header pins/unpins with a transform transition after the scroll event: settle twice */
    clearTimeout(settleA); clearTimeout(settleB);
    settleA = setTimeout(sync, 260);
    settleB = setTimeout(sync, 700);
  }
  window.addEventListener('scroll', onScroll, { passive: true });
  window.addEventListener('resize', request);
  if (header) header.addEventListener('transitionend', request);
  sync();
  setTimeout(sync, 300);
  setTimeout(sync, 1200);

  /* ---- Scrolling to a collection ---------------------------------------- */
  function scrollToSection(el) {
    var rect = el.getBoundingClientRect();
    /* the theme header hides while scrolling down and returns while scrolling up */
    var goingDown = rect.top > topPx + navHeight();
    var headerPart = goingDown ? 0 : (header ? header.offsetHeight : 0);
    var top = window.pageYOffset + rect.top - headerPart - navHeight();
    window.scrollTo({ top: Math.max(0, top), behavior: 'smooth' });
  }

  links.forEach(function (a) {
    a.addEventListener('click', function (e) {
      var id = a.getAttribute('data-oj-pairs-link');
      var el = id ? document.getElementById(id) : null;
      if (!el) return;
      e.preventDefault();
      lockUntil = Date.now() + 900;
      setActive(id);
      scrollToSection(el);
      if (window.history && window.history.replaceState) {
        try { window.history.replaceState(null, '', '#' + id); } catch (err) { /* ignore */ }
      }
    });
  });

  /* The hero sits in its own section, so listen on the document */
  document.addEventListener('click', function (e) {
    var cta = e.target.closest('[data-oj-pairs-explore]');
    if (!cta || !secs.length) return;
    e.preventDefault();
    lockUntil = Date.now() + 900;
    setActive(secs[0].id);
    scrollToSection(secs[0]);
  });

  /* ---- Add to bag -------------------------------------------------------- */
  function openCartDrawer() {
    try {
      if (window.cart_popup && typeof window.cart_popup.updateCartPopup === 'function' && window.jQuery) {
        window.cart_popup.updateCartPopup(function () {
          window.jQuery('.cart-popup-wrapper').addClass('open');
          window.jQuery('html').removeClass('cart-popup-wrapper-open').addClass('cart-popup-wrapper-open');
        });
      }
    } catch (err) { /* cart drawer unavailable */ }
  }
  function atLeast(started, ms) {
    var left = ms - (Date.now() - started);
    return new Promise(function (resolve) { setTimeout(resolve, Math.max(0, left)); });
  }

  function addToBag(btn) {
    if (btn.disabled || btn.classList.contains('is-adding') || btn.classList.contains('is-added')) return;
    var id = parseInt(btn.getAttribute('data-oj-pairs-add'), 10);
    if (!id) return;
    var card = btn.closest('[data-oj-pairs-card]');
    var labelEl = btn.querySelector('[data-oj-pairs-label]');
    var errorEl = card ? card.querySelector('[data-oj-pairs-error]') : null;
    var idle = btn.getAttribute('data-label') || '';
    var started = Date.now();

    function setLabel(text) { if (labelEl) labelEl.textContent = text; }
    function reset() {
      btn.classList.remove('is-adding', 'is-added');
      btn.removeAttribute('aria-disabled');
      setLabel(idle);
    }

    if (errorEl) { errorEl.hidden = true; errorEl.textContent = ''; }
    btn.classList.add('is-adding');
    btn.setAttribute('aria-disabled', 'true');
    setLabel(btn.getAttribute('data-label-adding') || idle);

    fetch(cartAddUrl, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
      body: JSON.stringify({ items: [{ id: id, quantity: 1 }] })
    })
      .then(function (res) { return res.json().then(function (data) { return { ok: res.ok, data: data }; }); })
      .then(function (r) {
        if (!r.ok || (r.data && r.data.status)) {
          throw new Error((r.data && (r.data.description || r.data.message)) || '');
        }
        return atLeast(started, 500);
      })
      .then(function () {
        btn.classList.remove('is-adding');
        btn.classList.add('is-added');
        setLabel(btn.getAttribute('data-label-added') || idle);
        openCartDrawer();
        document.dispatchEvent(new CustomEvent('oj-pairs:added', { detail: { variantId: id } }));
        setTimeout(reset, 2000);
      })
      .catch(function (err) {
        reset();
        if (errorEl) {
          errorEl.textContent = (err && err.message) || btn.getAttribute('data-label-error') || '';
          errorEl.hidden = !errorEl.textContent;
        }
      });
  }

  root.addEventListener('click', function (e) {
    var btn = e.target.closest('[data-oj-pairs-add]');
    if (!btn || !root.contains(btn)) return;
    e.preventDefault();
    addToBag(btn);
  });
})();
